module.exports = __webpack_public_path__ + "static/img/Store-13.4fcb4c17.png";